const EXTERNAL_LINKS = {
	tickets: "", // TODO
	sessions: "", // TODO
}

const TRACK_BREAK = (duration) => {
	return {
		duration: duration || 10,
		break: true,
		doNotEvaluate: true,
		title: {
			hr: "Pauza za kavu",
			en: "Coffee Break",
		},
		// poweredBy: {
		// 	name: "cWebSpace"
		// }
	}
}

const LUNCH_BREAK = (duration) => {
	return {
		duration: duration || 60,
		break: true,
		lunch: true,
		title: {
			hr: "Ručak",
			en: "Midday Break & Lunch",
		},
		// poweredBy: {
		// 	name: "Full Circle"
		// },
		description: {
			hr: "",
			en: [
				"<p>Take a breather. Grab some lunch from Full Circle, say hi to someone new or visit the partner booths.</p>",
				"<p>No rush - lunch will be available until 15:00.</p>"
			]
		},
	}
}

module.exports = {
	currentYear: 2027,
	dateLimits: {
		ticketSales: {
			weblica: {
				from: null,
				to: null, // TODO - this needs to match last ticket sale date
			},
			worklica: {
				from: null,
				to: null, // TODO - this needs to match last ticket sale date
			},
		},
		lectureRegistration: {
			from: null,
			to: null, // TODO
		},
		workshopRegistration: {
			from: null,
			to: null,
		},
		teamRegistration: {
			from: null,
			to: null,
		},
		sponsorRegistration: {
			from: null,
			to: null, // TODO
		},
		exhibitorRegistration: {
			from: null,
			to: null,
		},
		pressRegistration: {
			from: null,
			to: null, // TODO
		},
		volunteerRegistration: {
			from: null,
			to: null, // TODO
		},
		lastYearSurveyButton: {
			from: null,
			to: null,
		},
		registerToWorkshops: {
			from: null,
			to: null // by end of event since some may register just in time
		}
	},
	assets: {
		sponsorBrochure: {
			ident: {
				hr: "",
				en: "",
			},
			enabled: false,
		},
		exhibitorBrochure: {
			ident: {
				hr: "",
				en: "",
			},
			enabled: false,
		},
	},
	footerLinks: {
		code: {
			visible: true,
			extra: false,
			url: "/code",
			text: "more.code",
		},
		terms: {
			visible: true,
			extra: false,
			url: "/terms",
			text: "more.terms",
		},
		privacy: {
			visible: true,
			extra: false,
			url: "/privacy",
			text: "more.privacy",
		},
		recording: {
			visible: true,
			extra: false,
			url: "/recording",
			text: "more.recording",
		},
		safety: {
			visible: false,
			extra: true,
			url: "/safety",
			text: "more.safety",
		},
		press: {
			visible: true,
			extra: true,
			url: "/press",
			text: "more.press",
		},
		sponsor: {
			visible: true,
			extra: false,
			url: "/sponsors",
			text: "more.sponsor",
			dateLimit: "sponsorRegistration",
		},
		exhibitor: {
			visible: false,
			extra: false,
			url: "/exhibitors",
			text: "more.exhibitor",
			dateLimit: "exhibitorRegistration",
		},
		volunteer: {
			visible: true,
			extra: false,
			url: "/volunteer",
			text: "more.volunteer",
			dateLimit: "volunteerRegistration",
		}
	},
	events: {
		weblica: {
			previewMode: ["speakers", "schedule"],
			// workInProgress: ["speakers", "schedule"],
			tracks: [],
			externalLinks: EXTERNAL_LINKS,
			startDateTime: null, // TODO
			endDateTime: null, // TODO
			options: {
				entrioEventID: "", // TODO
			},
			topicsTags: {
				hr: [
					"<b>JavaScript</b>",
					"NodeJS",
					"Bun",
					"React",
					"Vue",
					"Ember",
					"Angular",
					"Svelte",
					"NextJS",
					"Gatsby",
					"NuxtJS",
					"...",
					"<b>PHP</b>",
					"Laravel",
					"Symphony",
					"CakePHP",
					"CodeIgniter",
					"Zend Framework",
					"...",
					"<b>.NET</b>",
					"Azure Cloud Development",
					"Xamarin",
					"Blazor",
					"ML.NET",
					"<b>Python</b>",
					"Flask",
					"Django",
					"CherryPy",
					"Bottle",
					"...",
					"Web",
					"APIs",
					"Services",
					"PWAs",
					"...",
					"<b>Security</b>",
					"OWASP",
					"PenTesting",
					"...",
					"UI",
					"UX",
					"...",
					"Git",
					"Docker",
					"DevOps",
					"Cloud",
					"...",
					"AI",
					"ChatBots",
					"LowCode/NoCode",
					"Blockchain",
					"...",
				],
				en: [
					"<b>JavaScript</b>",
					"NodeJS",
					"Bun",
					"React",
					"Vue",
					"Ember",
					"Angular",
					"Svelte",
					"NextJS",
					"Gatsby",
					"NuxtJS",
					"...",
					"<b>PHP</b>",
					"Laravel",
					"Symphony",
					"CakePHP",
					"CodeIgniter",
					"Zend Framework",
					"...",
					"<b>.NET</b>",
					"Azure Cloud Development",
					"Xamarin",
					"Blazor",
					"ML.NET",
					"<b>Python</b>",
					"Flask",
					"Django",
					"CherryPy",
					"Bottle",
					"...",
					"Web",
					"APIs",
					"Services",
					"PWAs",
					"...",
					"<b>Security</b>",
					"OWASP",
					"PenTesting",
					"...",
					"UI",
					"UX",
					"...",
					"Git",
					"Docker",
					"DevOps",
					"Cloud",
					"...",
					"AI",
					"ChatBots",
					"LowCode/NoCode",
					"Blockchain",
					"...",
				],
			},
			menuItems: {
				about: {
					url: "/weblica#about",
					visible: false,
				},
				news: {
					url: "/weblica#news",
					visible: false,
				},
				speakers: {
					url: "/weblica#speakers",
					visible: true,
				},
				schedule: {
					url: "/weblica#schedule",
					visible: true,
				},
				venue: {
					url: "/weblica#venue",
					visible: "active,before", // true || false || "active,before,after" (status dependant)
				},
				faq: {
					url: "/weblica#faq",
					visible: "active,before",
				},
				sponsors: {
					url: "/weblica#sponsors",
					visible: true,
				},
				tickets: {
					url: "/weblica#tickets",
					visible: false,
				},
				testimonials: {
					url: "/weblica#testimonials",
					visible: false,
				},
			},
			buttons: {
				lecture: {
					title: "Call for Speakers",
					url: EXTERNAL_LINKS.sessions,
					hollow: true,
					external: true,
					visible: false,
					visibleOnHero: false, // TODO - true
					wide: true,
					// full: true,
					dateLimit: "lectureRegistration",
				},
				tickets: {
					title: "Get Tickets",
					url: "/weblica#tickets",
					hollow: false,
					external: false,
					visible: false, // TODO - true,
					dateLimit: "ticketSales.weblica",
					//---
					visibleOnHero: false, // TODO - true,
					hollowOnHero: true,
					extraClassesOnHero: ["showOnSmall"],
					//---
					floatingSpecial: {
						// if defined, it will override given when on floating menu - this jumps directly to Entrio instead of to #tickets section
						url: EXTERNAL_LINKS.tickets,
						external: true,
					},
				},
			},
			forcedButtons: {
				sponsor: {
					title: "Become a Sponsor",
					url: "/sponsors",
					hollow: true,
					external: false,
					visible: true,
					linkInFooter: true,
					dateLimit: "sponsorRegistration",
				},
				exhibitor: {
					title: "Become an Exhibitor",
					url: "/exhibitors",
					hollow: true,
					external: false,
					visible: false,
					linkInFooter: false,
					dateLimit: "exhibitorRegistration",
				},
				volunteer: {
					title: "Become a Volunteer",
					url: "/volunteer",
					hollow: true,
					external: false,
					visible: false,
					linkInFooter: true,
					dateLimit: "volunteerRegistration",
				},
			},
			sections: {
				hero: { // TODO - update images
					visible: true,
					bgImage: "/media/WEBLICA_banner_1920x1080.png",
					introImage: {
						img: "1-weblica_2026-211.jpg",
						alt: "Hero Image",
					},
					blocks: [],
				},
				about: { // TODO - update images
					visible: true,
					blocks: [
						{
							width: "half", // full || half
							image: {
								file: "2-weblica_2026-468.jpg",
								alt: "Weblica 2026",
							},
						},
						{
							width: "half",
							text: "txt_aaa",
						},
						{
							width: "half",
							text: "txt_bbb",
						},
						{
							width: "half",
							image: {
								file: "3-weblica_2026-273.jpg",
								alt: "Weblica 2026",
							},
						},
						{
							width: "half",
							gallery: [
								{
									img: "4-weblica_2026-393.jpg",
									alt: "Weblica 2026",
								},
								{
									img: "5-weblica_2026-303.jpg",
									alt: "Weblica 2026",
								},
								{
									img: "6-weblica_2026-404.jpg",
									alt: "Weblica 2026",
								},
								{
									img: "7-weblica_2026-111.jpg",
									alt: "Weblica 2026",
								},
							],
						},
						{
							width: "half",
							text: "txt_ccc",
						},
					],
				},
				news: {
					visible: false,
				},
				speakers: {
					visible: true,
				},
				schedule: {
					visible: true,
				},
				venue: {
					visible: true, // TODO - true
				},
				tickets: {
					visible: false, // TODO - true
				},
				faq: {
					visible: true,
				},
				testimonials: {
					visible: true,
				},
				historyGallery: {
					visible: true,
				},
				sponsors: {
					visible: true,
				},
				newsletter: {
					visible: true,
				},
			},
			venue: {
				venue: "terme-sveti-martin",
			},
			tickets: [],
			"sessions": [], // TODO
			"speakers": {}, // TODO
			schedule: [], // TODO
			faq: {
				hr: [
					{
						title: "Što je Weblica?",
						short: "",
						full: "Weblica je konferencija posvećena web tehnologijama i IT sektoru koja okuplja različite stručnjake i entuzijaste iz cijele regije.",
					},
					// { // TODO: reactivate when dates are available
					// 	title: "Gdje i kada će se održati Weblica {{currentYear}}?",
					// 	short: "",
					// 	full: [
					// 		"Weblica {{currentYear}} održat će se {{eventDate}} s početkom u {{eventTime}} sati.<br/>",
					// 		"Adresa: {{venueNameAndAddress}}<br/><br/>",
					// 		"Pronađi lokaciju <a href='{{mapUrl}}' target='_blank'>na ovoj karti</a>.",
					// 	],
					// },
					// { // TODO: reactivate when dates are available
					// 	title: "Kako se prijaviti za sudjelovanje kao predavač na Weblici i koji je rok za prijavu?",
					// 	short: "",
					// 	full: [
					// 		`Prijave za predavače završavaju {{lectureRegistration.to}} u ponoć, a prijaviti se možete putem <a href='{{sessionsUrl}}' target='_blank'>Sessionize platforme</a>`,
					// 	],
					// },
					{
						title: "Koji su glavni sadržaji konferencije?",
						short: "",
						full: "Konferencija obuhvaća  razna predavanja, radionice i panel diskusije o najnovijim trendovima i temama u web tehnologijama.",
					},
					{
						title: "Koja je ciljna publika Weblice?",
						short: "",
						full: "Weblica okuplja stručnjake iz IT sektora, developere, programere, dizajnere, poduzetnike te sve koji su strastveni prema web tehnologijama.",
					},
					{
						title: "Kako mogu postati sponzor Weblice?",
						short: "",
						full: "Ako ste zainteresirani za sponzorstvo, pošaljite nam upit <a href='/{{linkLang}}/sponsors'>korištenjem ove forme.</a>",
					},
					// { // TODO: reactivate when dates are available
					// 	title: "Je li sudjelovanje na Weblici besplatno?",
					// 	short: "",
					// 	full: "Nažalost ne, ali cijene su iznimno pristupačne. Više informacija možete saznati na <a href='/{{linkLang}}/{{event}}/#tickets'>ovdje</a>.",
					// },
					{
						title: "Trebam li imati tehničko predznanje za sudjelovanje na konferenciji?",
						short: "",
						full: "Weblica je namijenjena različitim razinama znanja, tako da i početnici i oni iskusniji mogu pronaći relevantne sadržaje.",
					},
					{
						title: "Kako mogu volontirati na konferenciji?",
						short: "",
						full: "Volonteri su i više nego dobro došli. Ako si zainteresiran(a) za sudjelovanje kao volonter, <a href='/{{linkLang}}/volunteer'>popuni ovu formu</a>.",
					},
					{
						title: "Hoće li negdje biti omogućeno parkirati automobil?",
						short: "",
						full: "Da, omogućen je besplatan parking.",
					},
				],
				en: [
					{
						title: "What is Weblica?",
						short: "",
						full: "Weblica is a conference dedicated to web technologies and the IT sector that brings together various experts and enthusiasts from the entire region.",
					},
					{
						title: "Do I need to have technical background to participate?",
						short: "",
						full: "Our conference is designed for attendees of all knowledge levels. We select sessions that are accessible to a broader audience, but also include advanced topics for more experienced participants. Each session is labeled with the required knowledge level, so you’ll know in advance if it’s beginner-friendly or more suited to experts.",
					},
					// { // TODO: reactivate when dates are available
					// 	title: "Where and when will Weblica {{currentYear}} be held?",
					// 	short: "",
					// 	full: [
					// 		"<p>Weblica {{currentYear}} will be held on <b>{{eventDate}}</b>, starting at {{eventTime}}.<br/>",
					// 		"It will be held at <a href='/{{event}}/{{linkLang}}#venue'><b>{{venueName}}</b></a><b>, {{venueAddress}}</b>.</p>",
					// 	],
					// },
					// { // TODO: reactivate when dates are available
					// 	title: "How to apply for participation as a speaker and what is the application deadline?",
					// 	short: "",
					// 	full: `Applications for speakers end on {{lectureRegistration.to}} at midnight, and you can register via <a href='{{sessionsUrl}}' target='_blank'>Sessionize platform</a>`,
					// },
					{
						title: "What is the target audience?",
						short: "",
						full: "Weblica brings together experts from the IT sector, developers, programmers, designers, entrepreneurs and everyone who is passionate about web technologies.",
					},
					{
						title: "How can I become a sponsor?",
						short: "",
						full: "If you are interested in sponsorship, please send us an inquiry <a href='{{urlPrefix}}/{{linkLang}}/sponsors'>using this form.</a>",
					},
					{
						title: "How can I volunteer at the conference?",
						short: "",
						full: "Volunteers are more than welcome. If you are interested in participating, please <a href='{{urlPrefix}}/{{linkLang}}/volunteer'>use this form</a>.",
					},
					// { // TODO: reactivate when dates are available
					// 	title: "Is participation free of charge?",
					// 	short: "",
					// 	full: "Unfortunately not. <a href='{{urlPrefix}}/{{linkLang}}/{{event}}/#tickets'>Check out the tickets</a>",
					// },
					{
						title: "Can I get a refund if I can not longer attend?",
						short: "",
						full: "No, we do not provide refunds, but we can authorize ticket transfer.<br/>Please contact us at <a href='mailto:info@weblica.hr' targget='_blank'>info@weblica.hr</a>.",
					},
					{
						title: "Will it be possible to park a car somewhere?",
						short: "",
						full: "Yes, free parking is available.",
					}
				],
			},
			news: {
				en: [],
				hr: [],
			},
			testimonials: [ // TODO (low) - add selected testimonials from 2026 survey
				{
					speaker: true,
					name: "Frank",
					description: {
						hr: "Data Architect",
						en: "Data Architect",
					},
					text: {
						hr: [
							'<p>The tangible "startup energy", crowd enthusiasm, and passion for engagement with all the participants was a real boost for me. While a lot of the content was in Croatian, everyone I talked to in groups and in person made an effort to communicate in English (and a bit of German!). The food, weather and setting were also wonderful!! I look forward to following your growth and returning again next year!</p>',
						],
						en: [
							'<p>The tangible "startup energy", crowd enthusiasm, and passion for engagement with all the participants was a real boost for me. While a lot of the content was in Croatian, everyone I talked to in groups and in person made an effort to communicate in English (and a bit of German!). The food, weather and setting were also wonderful!! I look forward to following your growth and returning again next year!</p>',
						],
					},
				},
				{
					name: "Ivan",
					description: {
						hr: "developer",
						en: "Developer",
					},
					text: {
						hr: [
							"<p>Na Weblici sam naučio puno novih i korisnih stvari koje koristim svakoga dana, a osim predavanja - ekipa i hrana su super. </p>",
						],
						en: [
							"<p>At Weblica, I learned many new and useful things that I use every day, and besides the lectures - the team and the food are great.</p>",
						],
					},
				},
				{
					speaker: true,
					name: "Marko",
					description: {
						hr: "developer",
						en: "Developer",
					},
					text: {
						hr: [
							"<p>Weblica je sinonim za vrhunske predavače,najnovije trendove u IT-u, pregršt zabave i druženje s kolegama. Zato obavezno stavite Weblicu u vaš kalendar i vidimo se u svibnju u Čakovcu.</p>",
						],
						en: [
							"<p>Weblica is synonymous with top-notch speakers, the latest trends in IT, loads of fun, and networking with colleagues. That's why you should definitely put Weblica in your calendar and see you in May in Čakovec.</p>",
						],
					},
				},
				{
					speaker: true,
					name: "Tomislav",
					description: {
						hr: "Dizajner",
						en: "Designer",
					},
					text: {
						hr: [
							"<p>Weblica je jedno predivno iskustvo jer su prisutni ljudi poput vas, ljudi koji rade isti posao i koji su uspjeli u karijeri koju svi dijelimo. Može se jako puno naučiti iiz predavanja, ali i direktne komunikacije s predavačima jer to nisu neki tamo eterični ljudi iz cijelog svijeta - to su ljudi iz naše okoline koji znaju svoj posao. Mislim da je Weblica super prilika za naučiti nešto novo i napredovati u svojoj karijeri.</p>",
							"<p>Ekipa koja organizira Weblicu, koja stoji iza nje, je zakon. Atmosfera je fantastična i vidi se da ljudi rade sa strašću. Preporučam konferenciju svakome, neće faliti ni dobre zabave, ni hrane, a ni pića.</p>",
						],
						en: [
							"<p>Weblica is one marvelous experience because it is attended by people like you, people who do the same job and who have succeeded in the career we all share. There's so much to learn not only from the lectures but also from direct communication with the speakers because they aren't just some ethereal people from around the world - they are people from our environment who know their job. I think Weblica is a great opportunity to learn something new and advance in your career.</p>",
							"<p>The team organizing Weblica, who stands behind it, is awesome. The atmosphere is fantastic and you can see that people work with passion. I recommend the conference to everyone, there will be no shortage of good fun, food, or drinks.</p>",
						],
					},
				},
				{
					name: "Kristina",
					description: {
						hr: "Developer",
						en: "Developer",
					},
					text: {
						hr: [
							"<p>Weblica 2024 bila je vrlo zanimljivo iskustvo. Predavanja kojima sam se pridružila bile su stvarno informativne. Potvrdila sam neke stvari koje sam već znala i naučila puno novih ideja. Iskreno, hrana je bila puno bolja nego što sam očekivala. Dobra raznolikost, i nisam otišla gladna.</p>",
						],
						en: [
							"<p>Weblica 2024 was a very interesting experience. The sessions I joined were really informative. I confirmed some things I already knew and learned a lot of new ideas. Honestly, the food was way better than I expected. Good variety, and I didn’t go hungry.</p>",
						],
					},
				},
				{
					name: "Davor",
					description: {
						hr: "Developer",
						en: "Developer",
					},
					text: {
						hr: [
							"<p>Na Weblicu dolazim od njenog drugog izdanja, i od tad sam stalni član i posjetitelj ovog eventa. Po mojem, ovo je najbolji event u ovoj regiji, što se tiče programske i dizajnerske industrije. Vidimo se na druženju uz pive i ostalo.</p>",
						],
						en: [
							"<p>I have been coming to Weblica since its second edition. In my opinion, this is the best event in this region regarding the programming and design industry. Hope to see you at the gathering with beers and the rest.</p>",
						],
					},
				},
				{
					name: "Viktor",
					description: {
						hr: "Developer",
						en: "Developer",
					},
					text: {
						hr: [
							"<p>Na Weblicu se vraćam svake godine. Sviđa mi se networking, druženje s ljudima, super je ekipa i super su predavanja. Bilo bi mi drago da ima više tema vezanih uz Java programiranje.</p>",
						],
						en: [
							"<p>I come to Weblica every year. I like networking and socializing with people, the team is great and so are the lectures. I would be glad if there were more topics related to Java programming.</p>",
						],
					},
				},
				{
					name: "Nikola",
					description: {
						hr: "Developer",
						en: "Developer",
					},
					text: {
						hr: [
							"<p>Weblicu pratim od 2019., a 2024. mi je bila najbolja do sada. Mjesto je bilo dobro, a dvije paralelne staze olakšale su odabir sesija koje su mi odgovarale. Neke su se sesije mogle malo dublje pozabaviti temom, ali sve u svemu, svakako je vrijedilo posjetiti. I, naravno, druženje s momcima iz industrije učinilo ga je još posebnijim i nezaboravnijim.</p>",
						],
						en: [
							"<p>I've attended Weblica since 2019, and the 2024 one was the best so far. The venue was good, and having two parallel tracks made it easy to pick sessions that suited me. Some sessions could have gone a bit deeper into the subject, but overall, it was definitely worth the visit. And, of course, catching up with fellas from the industry made it all the more special and memorable.</p>",
						],
					},
				},
			],
			extraContent: [],
		},
		hacklica: {
			config: { // override config.js setup - disable this event for year 2026
				enabled: false,
				active: false,
				visible: false,
				visibleInHeader: false,
			},
			startDateTime: null, // "2025-05-03 08:00:00",
			endDateTime: null, // "2025-05-04 08:00:00",
			specialDates: {
				demos: null,
				winningCeremony: null,
			},
			prizeAmounts: [5000, 3000, 1500],
			menuItems: {
				about: {
					menu: "About",
					url: "/hacklica#about",
					visible: false,
				},
				news: {
					menu: "News",
					url: "/hacklica#news",
					visible: false,
				},
				topics: {
					menu: "Topics",
					url: "/hacklica#topics",
					visible: false,
				},
				venue: {
					menu: "Venue",
					url: "/hacklica#venue",
					visible: false,
				},
				faq: {
					menu: "FAQ",
					url: "/hacklica#faq",
					visible: false,
				},
				sponsors: {
					menu: "Sponsors",
					url: "/hacklica#sponsors",
					visible: false,
				},
				terms: {
					menu: "Terms",
					url: "/hacklica/terms",
					special: true,
					visible: false,
				},
				policy: {
					menu: "Policy",
					url: "/hacklica/policy",
					special: true,
					visible: false,
				},
			},
			buttons: {
				register: {
					title: "Register your team",
					url: "/hacklica/register",
					hollow: true,
					dateLimit: "teamRegistration",
					visible: false,
				},
			},
			forcedButtons: {
				sponsor: {
					title: "Become a Sponsor",
					url: "/sponsors",
					hollow: true,
					external: false,
					visible: false,
					dateLimit: "sponsorRegistration",
				},
			},
			sections: {
				hero: {
					visible: true,
					bgImage: "/media/WEBLICA_banner_1920x1080.png",
					// introImage: {
					// 	img: "hacklica-2019-2.jpg",
					// 	alt: "Hacklica 2019",
					// },
					// introVideo: [
					// 	{
					// 		media: "(max-width: 640px)",
					// 		url: "/media/WEBLICA_banner_animation_640x360.mp4",
					// 		poster: "/media/WEBLICA_banner_1280x720.png",
					// 		type: "video/mp4",
					// 	},
					// 	{
					// 		media: "(max-width: 1280px)",
					// 		url: "/media/WEBLICA_banner_animation_1280x720.mp4",
					// 		poster: "/media/WEBLICA_banner_1280x720.png",
					// 		type: "video/mp4",
					// 	},
					// 	{
					// 		media: "(min-width: 1281px)",
					// 		url: "/media/WEBLICA_banner_animation_1920x1080.mp4",
					// 		poster: "/media/WEBLICA_banner_1920x1080.png",
					// 		type: "video/mp4",
					// 	},
					// ],
					blocks: [],
				},
				about: {
					visible: true,
					blocks: [
						{
							width: "half", // full || half
							image: {
								file: "hacklica-2019-3.jpg",
								alt: "Hacklica 2019",
							},
						},
						{
							width: "half",
							text: "txt_aaa",
						},
					],
				},
				news: {
					visible: false,
				},
				topics: {
					visible: true,
				},
				venue: {
					visible: true,
				},
				faq: {
					visible: true,
				},
				sponsors: {
					visible: true,
				},
				newsletter: {
					visible: true,
				},
				testimonials: {
					visible: false,
				},
				historyGallery: {
					visible: true,
				},
			},
			__venue: {
				name: {
					hr: "Graditeljska škola",
					en: "School of Architecture",
				},
				nameAlt: {
					hr: "Dvorana Graditeljske škole",
					en: "Hall of the School of Architecture",
				},
				street: "Športska ulica 1",
				postalCode: "40000",
				city: "Čakovec",
				country: "Croatia",
				countryShort: "HR",
				leaflet: {
					location: [46.38921, 16.42269],
					zoom: 19,
				},
				mapUrl:
					"https://www.google.com/maps/place/Graditeljska+%C5%A1kola+%C4%8Cakovec/@46.3888122,16.4220393,15z/data=!4m5!3m4!1s0x0:0x129b433371a3c66f!8m2!3d46.3888122!4d16.4220399",
				mapImage: "gsc-dvorana-map.png",
				images: ["gsc-dvorana-1.jpeg", "gsc-dvorana-2.jpeg"],
			},
			__faq: {
				hr: [
					{
						title: "HR-HH-faq 1",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "faq 2",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "faq 3",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "faq 4",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "faq 5",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "faq 6",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "faq 7",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "faq 8",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
				],
				en: [
					{
						title: "EN-What is the smallest or the largest team size?",
						short:
							"Minimum is 2 members (as you probably expected) and the largest team can have up to 6 members. Everything in between is fine by us.",
						full: "Minimum is 2 members (as you probably expected) and the largest team can have up to 6 members. Everything in between is fine by us.",
					},
					{
						title: "Can we base our work on preexisting work of ours?",
						short: "Short answer would be-no! But ...",
						full: "If your team has some utilities or smaller libraries that can aid you, yes, you can use that. But beware! We will check the code (it is part of judging process) and we will disqualify full teams if we notice that code volume is not consistent with what is possible in 24 hour window. You will be able to speak up of course if such event occurs, but we are all seniors here and can not be fooled so easily!",
					},
					{
						title: "faq 3",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "faq 4",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
				],
			},
			__news: {
				hr: [
					{
						title: "HR-HH-here we go again",
						when: "2021-09-01 08:00",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "HH-here we go again #2",
						when: "2021-09-03 08:00",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "",
					},
					{
						title: "HH-full steam ahead",
						when: "2021-11-01 08:00",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "<b>Cherry bomb</b> lemongrass cranberry spritzer shallots cookies potato overflowing berries cool off fall apricot blood orange smash. Hearts of palm heat arugula salad second course garlic sriracha noodles blueberry chia seed jam crunchy seaweed green onions hemp seeds raspberry fizz enchiladas green bowl double dark chocolate Mexican fiesta spicy pineapple salsa ultra creamy avocado pesto red amazon pepper chili peppermint tomato and basil. Blackberries cocoa parsley thyme lychee farro platter cool cucumbers peanut butter crunch burritos homemade balsamic cool lemon tahini dressing mint lime taco salsa eating together coriander cherry.<br/><br/>Street style Thai basil tacos Chinese five-spice powder overflowing Bulgarian carrot Thai curry Indian spiced Thai sun pepper blueberries plums red curry tofu noodles walnut mushroom tart blueberry pops tempeh almond milk bite sized. Chickpea crust pizza kale caesar salad crunchy orange pinch of yum scotch bonnet pepper roasted brussel sprouts açai simmer cauliflower picnic strawberry mango smoothie cherries vitamin glow rich coconut cream red lentil curry casserole veggie burgers alfalfa sprouts pomegranate lemon lime minty black bean chili dip.<br/><br/>Seitan summer fruit salad Sicilian pistachio pesto smoky maple tempeh glaze roasted butternut squash raspberries kale chili pepper sweet potato salted crumbled lentils ginger tofu ginger carrot spiced juice Bolivian rainbow pepper salad sriracha pecans cozy butternut creamiest green papaya salad sandwiches smoked tofu chai tea. Peaches hearty grains citrusy mediterranean sesame soba noodles butternut mix Southern Italian Thai dragon pepper avocado dressing drizzle broccoli chocolate cookie mushroom risotto tasty chocolate peanut butter dip sleepy morning tea artichoke hearts coconut rice vine tomatoes cremini mushrooms chia seeds cinnamon peach strawberry mango creamy cauliflower alfredo sauce mediterranean luxury bowl red grapes.<br/><br/>Balsamic vinaigrette maple orange tempeh green tea lime shiitake mushrooms samosa bento box grapefruit dessert almond milk chai latte cayenne banh mi salad rolls couscous. Red pepper ginger lemongrass agave green tea with cinnamon toast habanero golden four-layer pumpkin hazelnut shiitake jalapeño dill udon noodles a delicious meal ultimate dragon fruit avocado basil pesto ghost pepper fresh chocolate basil cilantro cilantro lime vinaigrette candy cane winter peanut butter fiery fruit winter soba noodles.",
					},
					{
						title: "HH-tickets are ready-go go go",
						when: "2024-01-01 08:00",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
				],
				en: [
					{
						title: "EN-HH-here we go again",
						when: "2021-09-01 08:00",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "HH-here we go again #2",
						when: "2021-09-03 08:00",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "",
					},
					{
						title: "HH-full steam ahead",
						when: "2021-11-01 08:00",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "<b>Cherry bomb</b> lemongrass cranberry spritzer shallots cookies potato overflowing berries cool off fall apricot blood orange smash. Hearts of palm heat arugula salad second course garlic sriracha noodles blueberry chia seed jam crunchy seaweed green onions hemp seeds raspberry fizz enchiladas green bowl double dark chocolate Mexican fiesta spicy pineapple salsa ultra creamy avocado pesto red amazon pepper chili peppermint tomato and basil. Blackberries cocoa parsley thyme lychee farro platter cool cucumbers peanut butter crunch burritos homemade balsamic cool lemon tahini dressing mint lime taco salsa eating together coriander cherry.<br/><br/>Street style Thai basil tacos Chinese five-spice powder overflowing Bulgarian carrot Thai curry Indian spiced Thai sun pepper blueberries plums red curry tofu noodles walnut mushroom tart blueberry pops tempeh almond milk bite sized. Chickpea crust pizza kale caesar salad crunchy orange pinch of yum scotch bonnet pepper roasted brussel sprouts açai simmer cauliflower picnic strawberry mango smoothie cherries vitamin glow rich coconut cream red lentil curry casserole veggie burgers alfalfa sprouts pomegranate lemon lime minty black bean chili dip.<br/><br/>Seitan summer fruit salad Sicilian pistachio pesto smoky maple tempeh glaze roasted butternut squash raspberries kale chili pepper sweet potato salted crumbled lentils ginger tofu ginger carrot spiced juice Bolivian rainbow pepper salad sriracha pecans cozy butternut creamiest green papaya salad sandwiches smoked tofu chai tea. Peaches hearty grains citrusy mediterranean sesame soba noodles butternut mix Southern Italian Thai dragon pepper avocado dressing drizzle broccoli chocolate cookie mushroom risotto tasty chocolate peanut butter dip sleepy morning tea artichoke hearts coconut rice vine tomatoes cremini mushrooms chia seeds cinnamon peach strawberry mango creamy cauliflower alfredo sauce mediterranean luxury bowl red grapes.<br/><br/>Balsamic vinaigrette maple orange tempeh green tea lime shiitake mushrooms samosa bento box grapefruit dessert almond milk chai latte cayenne banh mi salad rolls couscous. Red pepper ginger lemongrass agave green tea with cinnamon toast habanero golden four-layer pumpkin hazelnut shiitake jalapeño dill udon noodles a delicious meal ultimate dragon fruit avocado basil pesto ghost pepper fresh chocolate basil cilantro cilantro lime vinaigrette candy cane winter peanut butter fiery fruit winter soba noodles.",
					},
					{
						title: "HH-tickets are ready-go go go",
						when: "2024-01-01 08:00",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
				],
			},
			__topics: {
				hr: [
					{
						title: "HR topic 1",
						short:
							"HR Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
						full: "<b>Cherry bomb</b> lemongrass cranberry spritzer shallots cookies potato overflowing berries cool off fall apricot blood orange smash. Hearts of palm heat arugula salad second course garlic sriracha noodles blueberry chia seed jam crunchy seaweed green onions hemp seeds raspberry fizz enchiladas green bowl double dark chocolate Mexican fiesta spicy pineapple salsa ultra creamy avocado pesto red amazon pepper chili peppermint tomato and basil. Blackberries cocoa parsley thyme lychee farro platter cool cucumbers peanut butter crunch burritos homemade balsamic cool lemon tahini dressing mint lime taco salsa eating together coriander cherry.<br/><br/>Street style Thai basil tacos Chinese five-spice powder overflowing Bulgarian carrot Thai curry Indian spiced Thai sun pepper blueberries plums red curry tofu noodles walnut mushroom tart blueberry pops tempeh almond milk bite sized. Chickpea crust pizza kale caesar salad crunchy orange pinch of yum scotch bonnet pepper roasted brussel sprouts açai simmer cauliflower picnic strawberry mango smoothie cherries vitamin glow rich coconut cream red lentil curry casserole veggie burgers alfalfa sprouts pomegranate lemon lime minty black bean chili dip.<br/><br/>Seitan summer fruit salad Sicilian pistachio pesto smoky maple tempeh glaze roasted butternut squash raspberries kale chili pepper sweet potato salted crumbled lentils ginger tofu ginger carrot spiced juice Bolivian rainbow pepper salad sriracha pecans cozy butternut creamiest green papaya salad sandwiches smoked tofu chai tea. Peaches hearty grains citrusy mediterranean sesame soba noodles butternut mix Southern Italian Thai dragon pepper avocado dressing drizzle broccoli chocolate cookie mushroom risotto tasty chocolate peanut butter dip sleepy morning tea artichoke hearts coconut rice vine tomatoes cremini mushrooms chia seeds cinnamon peach strawberry mango creamy cauliflower alfredo sauce mediterranean luxury bowl red grapes.<br/><br/>Balsamic vinaigrette maple orange tempeh green tea lime shiitake mushrooms samosa bento box grapefruit dessert almond milk chai latte cayenne banh mi salad rolls couscous. Red pepper ginger lemongrass agave green tea with cinnamon toast habanero golden four-layer pumpkin hazelnut shiitake jalapeño dill udon noodles a delicious meal ultimate dragon fruit avocado basil pesto ghost pepper fresh chocolate basil cilantro cilantro lime vinaigrette candy cane winter peanut butter fiery fruit winter soba noodles.",
					},
					{
						title: "HR topic 2",
						short:
							"HR Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
						full: "<b>Cherry bomb</b> lemongrass cranberry spritzer shallots cookies potato overflowing berries cool off fall apricot blood orange smash. Hearts of palm heat arugula salad second course garlic sriracha noodles blueberry chia seed jam crunchy seaweed green onions hemp seeds raspberry fizz enchiladas green bowl double dark chocolate Mexican fiesta spicy pineapple salsa ultra creamy avocado pesto red amazon pepper chili peppermint tomato and basil. Blackberries cocoa parsley thyme lychee farro platter cool cucumbers peanut butter crunch burritos homemade balsamic cool lemon tahini dressing mint lime taco salsa eating together coriander cherry.<br/><br/>Street style Thai basil tacos Chinese five-spice powder overflowing Bulgarian carrot Thai curry Indian spiced Thai sun pepper blueberries plums red curry tofu noodles walnut mushroom tart blueberry pops tempeh almond milk bite sized. Chickpea crust pizza kale caesar salad crunchy orange pinch of yum scotch bonnet pepper roasted brussel sprouts açai simmer cauliflower picnic strawberry mango smoothie cherries vitamin glow rich coconut cream red lentil curry casserole veggie burgers alfalfa sprouts pomegranate lemon lime minty black bean chili dip.<br/><br/>Seitan summer fruit salad Sicilian pistachio pesto smoky maple tempeh glaze roasted butternut squash raspberries kale chili pepper sweet potato salted crumbled lentils ginger tofu ginger carrot spiced juice Bolivian rainbow pepper salad sriracha pecans cozy butternut creamiest green papaya salad sandwiches smoked tofu chai tea. Peaches hearty grains citrusy mediterranean sesame soba noodles butternut mix Southern Italian Thai dragon pepper avocado dressing drizzle broccoli chocolate cookie mushroom risotto tasty chocolate peanut butter dip sleepy morning tea artichoke hearts coconut rice vine tomatoes cremini mushrooms chia seeds cinnamon peach strawberry mango creamy cauliflower alfredo sauce mediterranean luxury bowl red grapes.<br/><br/>Balsamic vinaigrette maple orange tempeh green tea lime shiitake mushrooms samosa bento box grapefruit dessert almond milk chai latte cayenne banh mi salad rolls couscous. Red pepper ginger lemongrass agave green tea with cinnamon toast habanero golden four-layer pumpkin hazelnut shiitake jalapeño dill udon noodles a delicious meal ultimate dragon fruit avocado basil pesto ghost pepper fresh chocolate basil cilantro cilantro lime vinaigrette candy cane winter peanut butter fiery fruit winter soba noodles.",
					},
					{
						title: "HR topic 3",
						short:
							"HR Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
						full: "<b>Cherry bomb</b> lemongrass cranberry spritzer shallots cookies potato overflowing berries cool off fall apricot blood orange smash. Hearts of palm heat arugula salad second course garlic sriracha noodles blueberry chia seed jam crunchy seaweed green onions hemp seeds raspberry fizz enchiladas green bowl double dark chocolate Mexican fiesta spicy pineapple salsa ultra creamy avocado pesto red amazon pepper chili peppermint tomato and basil. Blackberries cocoa parsley thyme lychee farro platter cool cucumbers peanut butter crunch burritos homemade balsamic cool lemon tahini dressing mint lime taco salsa eating together coriander cherry.<br/><br/>Street style Thai basil tacos Chinese five-spice powder overflowing Bulgarian carrot Thai curry Indian spiced Thai sun pepper blueberries plums red curry tofu noodles walnut mushroom tart blueberry pops tempeh almond milk bite sized. Chickpea crust pizza kale caesar salad crunchy orange pinch of yum scotch bonnet pepper roasted brussel sprouts açai simmer cauliflower picnic strawberry mango smoothie cherries vitamin glow rich coconut cream red lentil curry casserole veggie burgers alfalfa sprouts pomegranate lemon lime minty black bean chili dip.<br/><br/>Seitan summer fruit salad Sicilian pistachio pesto smoky maple tempeh glaze roasted butternut squash raspberries kale chili pepper sweet potato salted crumbled lentils ginger tofu ginger carrot spiced juice Bolivian rainbow pepper salad sriracha pecans cozy butternut creamiest green papaya salad sandwiches smoked tofu chai tea. Peaches hearty grains citrusy mediterranean sesame soba noodles butternut mix Southern Italian Thai dragon pepper avocado dressing drizzle broccoli chocolate cookie mushroom risotto tasty chocolate peanut butter dip sleepy morning tea artichoke hearts coconut rice vine tomatoes cremini mushrooms chia seeds cinnamon peach strawberry mango creamy cauliflower alfredo sauce mediterranean luxury bowl red grapes.<br/><br/>Balsamic vinaigrette maple orange tempeh green tea lime shiitake mushrooms samosa bento box grapefruit dessert almond milk chai latte cayenne banh mi salad rolls couscous. Red pepper ginger lemongrass agave green tea with cinnamon toast habanero golden four-layer pumpkin hazelnut shiitake jalapeño dill udon noodles a delicious meal ultimate dragon fruit avocado basil pesto ghost pepper fresh chocolate basil cilantro cilantro lime vinaigrette candy cane winter peanut butter fiery fruit winter soba noodles.",
					},
				],
				en: [
					{
						title: "EN topic 1",
						short:
							"EN Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
						full: "<b>Cherry bomb</b> lemongrass cranberry spritzer shallots cookies potato overflowing berries cool off fall apricot blood orange smash. Hearts of palm heat arugula salad second course garlic sriracha noodles blueberry chia seed jam crunchy seaweed green onions hemp seeds raspberry fizz enchiladas green bowl double dark chocolate Mexican fiesta spicy pineapple salsa ultra creamy avocado pesto red amazon pepper chili peppermint tomato and basil. Blackberries cocoa parsley thyme lychee farro platter cool cucumbers peanut butter crunch burritos homemade balsamic cool lemon tahini dressing mint lime taco salsa eating together coriander cherry.<br/><br/>Street style Thai basil tacos Chinese five-spice powder overflowing Bulgarian carrot Thai curry Indian spiced Thai sun pepper blueberries plums red curry tofu noodles walnut mushroom tart blueberry pops tempeh almond milk bite sized. Chickpea crust pizza kale caesar salad crunchy orange pinch of yum scotch bonnet pepper roasted brussel sprouts açai simmer cauliflower picnic strawberry mango smoothie cherries vitamin glow rich coconut cream red lentil curry casserole veggie burgers alfalfa sprouts pomegranate lemon lime minty black bean chili dip.<br/><br/>Seitan summer fruit salad Sicilian pistachio pesto smoky maple tempeh glaze roasted butternut squash raspberries kale chili pepper sweet potato salted crumbled lentils ginger tofu ginger carrot spiced juice Bolivian rainbow pepper salad sriracha pecans cozy butternut creamiest green papaya salad sandwiches smoked tofu chai tea. Peaches hearty grains citrusy mediterranean sesame soba noodles butternut mix Southern Italian Thai dragon pepper avocado dressing drizzle broccoli chocolate cookie mushroom risotto tasty chocolate peanut butter dip sleepy morning tea artichoke hearts coconut rice vine tomatoes cremini mushrooms chia seeds cinnamon peach strawberry mango creamy cauliflower alfredo sauce mediterranean luxury bowl red grapes.<br/><br/>Balsamic vinaigrette maple orange tempeh green tea lime shiitake mushrooms samosa bento box grapefruit dessert almond milk chai latte cayenne banh mi salad rolls couscous. Red pepper ginger lemongrass agave green tea with cinnamon toast habanero golden four-layer pumpkin hazelnut shiitake jalapeño dill udon noodles a delicious meal ultimate dragon fruit avocado basil pesto ghost pepper fresh chocolate basil cilantro cilantro lime vinaigrette candy cane winter peanut butter fiery fruit winter soba noodles.",
					},
					{
						title: "EN topic 2",
						short:
							"EN Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
						full: "<b>Cherry bomb</b> lemongrass cranberry spritzer shallots cookies potato overflowing berries cool off fall apricot blood orange smash. Hearts of palm heat arugula salad second course garlic sriracha noodles blueberry chia seed jam crunchy seaweed green onions hemp seeds raspberry fizz enchiladas green bowl double dark chocolate Mexican fiesta spicy pineapple salsa ultra creamy avocado pesto red amazon pepper chili peppermint tomato and basil. Blackberries cocoa parsley thyme lychee farro platter cool cucumbers peanut butter crunch burritos homemade balsamic cool lemon tahini dressing mint lime taco salsa eating together coriander cherry.<br/><br/>Street style Thai basil tacos Chinese five-spice powder overflowing Bulgarian carrot Thai curry Indian spiced Thai sun pepper blueberries plums red curry tofu noodles walnut mushroom tart blueberry pops tempeh almond milk bite sized. Chickpea crust pizza kale caesar salad crunchy orange pinch of yum scotch bonnet pepper roasted brussel sprouts açai simmer cauliflower picnic strawberry mango smoothie cherries vitamin glow rich coconut cream red lentil curry casserole veggie burgers alfalfa sprouts pomegranate lemon lime minty black bean chili dip.<br/><br/>Seitan summer fruit salad Sicilian pistachio pesto smoky maple tempeh glaze roasted butternut squash raspberries kale chili pepper sweet potato salted crumbled lentils ginger tofu ginger carrot spiced juice Bolivian rainbow pepper salad sriracha pecans cozy butternut creamiest green papaya salad sandwiches smoked tofu chai tea. Peaches hearty grains citrusy mediterranean sesame soba noodles butternut mix Southern Italian Thai dragon pepper avocado dressing drizzle broccoli chocolate cookie mushroom risotto tasty chocolate peanut butter dip sleepy morning tea artichoke hearts coconut rice vine tomatoes cremini mushrooms chia seeds cinnamon peach strawberry mango creamy cauliflower alfredo sauce mediterranean luxury bowl red grapes.<br/><br/>Balsamic vinaigrette maple orange tempeh green tea lime shiitake mushrooms samosa bento box grapefruit dessert almond milk chai latte cayenne banh mi salad rolls couscous. Red pepper ginger lemongrass agave green tea with cinnamon toast habanero golden four-layer pumpkin hazelnut shiitake jalapeño dill udon noodles a delicious meal ultimate dragon fruit avocado basil pesto ghost pepper fresh chocolate basil cilantro cilantro lime vinaigrette candy cane winter peanut butter fiery fruit winter soba noodles.",
					},
					{
						title: "EN topic 3",
						short:
							"EN Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
						full: "<b>Cherry bomb</b> lemongrass cranberry spritzer shallots cookies potato overflowing berries cool off fall apricot blood orange smash. Hearts of palm heat arugula salad second course garlic sriracha noodles blueberry chia seed jam crunchy seaweed green onions hemp seeds raspberry fizz enchiladas green bowl double dark chocolate Mexican fiesta spicy pineapple salsa ultra creamy avocado pesto red amazon pepper chili peppermint tomato and basil. Blackberries cocoa parsley thyme lychee farro platter cool cucumbers peanut butter crunch burritos homemade balsamic cool lemon tahini dressing mint lime taco salsa eating together coriander cherry.<br/><br/>Street style Thai basil tacos Chinese five-spice powder overflowing Bulgarian carrot Thai curry Indian spiced Thai sun pepper blueberries plums red curry tofu noodles walnut mushroom tart blueberry pops tempeh almond milk bite sized. Chickpea crust pizza kale caesar salad crunchy orange pinch of yum scotch bonnet pepper roasted brussel sprouts açai simmer cauliflower picnic strawberry mango smoothie cherries vitamin glow rich coconut cream red lentil curry casserole veggie burgers alfalfa sprouts pomegranate lemon lime minty black bean chili dip.<br/><br/>Seitan summer fruit salad Sicilian pistachio pesto smoky maple tempeh glaze roasted butternut squash raspberries kale chili pepper sweet potato salted crumbled lentils ginger tofu ginger carrot spiced juice Bolivian rainbow pepper salad sriracha pecans cozy butternut creamiest green papaya salad sandwiches smoked tofu chai tea. Peaches hearty grains citrusy mediterranean sesame soba noodles butternut mix Southern Italian Thai dragon pepper avocado dressing drizzle broccoli chocolate cookie mushroom risotto tasty chocolate peanut butter dip sleepy morning tea artichoke hearts coconut rice vine tomatoes cremini mushrooms chia seeds cinnamon peach strawberry mango creamy cauliflower alfredo sauce mediterranean luxury bowl red grapes.<br/><br/>Balsamic vinaigrette maple orange tempeh green tea lime shiitake mushrooms samosa bento box grapefruit dessert almond milk chai latte cayenne banh mi salad rolls couscous. Red pepper ginger lemongrass agave green tea with cinnamon toast habanero golden four-layer pumpkin hazelnut shiitake jalapeño dill udon noodles a delicious meal ultimate dragon fruit avocado basil pesto ghost pepper fresh chocolate basil cilantro cilantro lime vinaigrette candy cane winter peanut butter fiery fruit winter soba noodles.",
					},
				],
			},
		},
		worklica: {
			config: { // override config.js setup - disable this event for year 2026
				enabled: false,
				active: false,
				visible: false,
				visibleInHeader: false,
			},
			// previewMode: ["schedule"],
			// workInProgress: ["speakers", "schedule"],
			tracks: ["track1"],
			externalLinks: EXTERNAL_LINKS,
			startDateTime: "2026-05-08 10:10:00",
			endDateTime: "2026-05-08 23:59:59",
			options: {
				entrioEventID: "25646",
				enableWorkshopRegistration: true
			},
			menuItems: {
				about: {
					menu: "About",
					url: "/worklica#about",
					visible: false,
				},
				news: {
					menu: "News",
					url: "/worklica#news",
					visible: false,
				},
				speakers: {
					menu: "Speakers",
					url: "/worklica#speakers",
					visible: true,
				},
				schedule: {
					menu: "Schedule",
					url: "/worklica#schedule",
					visible: true,
				},
				tickets: {
					menu: "Tickets",
					url: "/worklica#tickets",
					visible: false,
				},
				venue: {
					menu: "Venue",
					url: "/worklica#venue",
					visible: "active,before",
				},
				faq: {
					menu: "FAQ",
					url: "/worklica#faq",
					visible: "active,before",
				},
				sponsors: {
					menu: "Sponsors",
					url: "/worklica#sponsors",
					visible: true,
				},
			},
			buttons: {
				register: {
					title: "Register a workshop",
					url: EXTERNAL_LINKS.sessions,
					hollow: true,
					external: true,
					visible: false,
					visibleOnHero: true,
					wide: true,
					// full: true,
					dateLimit: "workshopRegistration",
				},
				tickets: {
					title: "Get Tickets",
					url: "/worklica#tickets",
					hollow: false,
					external: false,
					visible: false, // XXX - true,
					dateLimit: "ticketSales.worklica",
					//---
					visibleOnHero: false, // XXX - true,
					hollowOnHero: true,
					extraClassesOnHero: ["showOnSmall"],
					// ---
					floatingSpecial: {
						// if defined, it will override given when on floating menu - this jumps directly to Entrio instead of to #tickets section
						url: EXTERNAL_LINKS.tickets,
						external: true,
					},
				},
			},
			forcedButtons: {
				sponsor: {
					title: "Become a Sponsor",
					url: "/sponsors",
					hollow: true,
					external: false,
					visible: true,
					linkInFooter: true,
					dateLimit: "sponsorRegistration",
				},
			},
			sections: {
				hero: {
					visible: true,
					bgImage: "/media/WEBLICA_banner_1920x1080.png",
					introImage: {
						// img: "WEBLICA_banner_1280x720.png",
						img: "Worklica 2025 (9).jpg",
						alt: "Hero Image",
					},
					// introImageRandom: [
					// 	{
					// 		img: "WEBLICA_banner_1280x720.png",
					// 		alt: "Worklica 2025",
					// 	},
					// 	{
					// 		img: "Worklica 2025 (28).jpg",
					// 		alt: "Worklica 2025",
					// 	},
					// 	{
					// 		img: "Worklica 2025 (9).jpg",
					// 		alt: "Worklica 2025",
					// 	},
					// 	{
					// 		img: "Worklica 2025 (21).jpg",
					// 		alt: "Worklica 2025",
					// 	},
					// 	{
					// 		img: "Worklica 2025 (247).jpg",
					// 		alt: "Worklica 2025",
					// 	},
					// ],
					// introVideo: [
					// 	{
					// 		media: "(max-width: 640px)",
					// 		url: "/media/WEBLICA_banner_animation_640x360.mp4",
					// 		poster: "/media/WEBLICA_banner_1280x720.png",
					// 		type: "video/mp4",
					// 	},
					// 	{
					// 		media: "(max-width: 1280px)",
					// 		url: "/media/WEBLICA_banner_animation_1280x720.mp4",
					// 		poster: "/media/WEBLICA_banner_1280x720.png",
					// 		type: "video/mp4",
					// 	},
					// 	{
					// 		media: "(min-width: 1281px)",
					// 		url: "/media/WEBLICA_banner_animation_1920x1080.mp4",
					// 		poster: "/media/WEBLICA_banner_1920x1080.png",
					// 		type: "video/mp4",
					// 	},
					// ],
					blocks: [],
				},
				about: {
					visible: true,
					blocks: [
						{
							width: "half", // full || half
							image: {
								file: "Worklica 2025 (12).jpg",
								alt: "Worklica 2025",
							},
						},
						{
							width: "half",
							text: "txt_aaa",
						},
						{
							width: "half",
							text: "txt_bbb",
						},
						{
							width: "half", // full || half
							image: {
								file: "Worklica 2025 (20).jpg",
								alt: "Worklica 2025",
							},
						},
					],
				},
				news: {
					visible: false,
				},
				speakers: {
					visible: true,
				},
				schedule: {
					visible: true,
				},
				venue: {
					visible: true,
				},
				tickets: {
					visible: false, // XXX - true,
				},
				faq: {
					visible: true,
				},
				sponsors: {
					visible: true,
				},
				newsletter: {
					visible: true,
				},
				testimonials: {
					visible: false,
				},
				historyGallery: {
					visible: true,
				},
			},
			venue: {
				venue: "terme-sveti-martin",
			},
			tickets: [],
			speakers: {},
			sessions: [],
			sessionAssets: [],
			schedule: [],
			faq: {
				hr: [],
				en: [
					{
						title: "Who is Worklica for?",
						short: "",
						full: "Worklica is designed for developers who want to explore technical challenges and solutions in greater detail. Unlike conference sessions, workshops offer more time to dig deeper into specific topics, sometimes requiring active participation. Each workshop will indicate whether hands-on involvement is expected.",
					},
					{
						title: "Do I need to have technical background to participate?",
						short: "",
						full: "The required knowledge level for each workshop depends on the topic. Some workshops will dive deep into technical subjects, while others may be more accessible to beginners. Each workshop will clearly state the knowledge level required, so you can choose the ones that best fit your experience.",
					},
					{
						title: "Where and when will Worklica {{currentYear}} be held?",
						short: "",
						full: [
							"<p>Worklica {{currentYear}} will be held on <b>{{eventDate}}</b>, starting at {{eventTime}}.<br/>",
							"It will be held at <a href='/{{event}}/{{linkLang}}#venue'><b>{{venueName}}</b></a><b>, {{venueAddress}}</b>.</p>",
						],
					},
					{
						title: "How to apply for participation as a lecturer and what is the application deadline?",
						short: "",
						full: `Applications for speakers end on {{workshopRegistration.to}} at midnight, and you can register via <a href='{{sessionsUrl}}' target='_blank'>Sessionize platform</a> (please notice Session type entry).`,
					},
					{
						title: "How can I become a Worklica sponsor?",
						short: "",
						full: "If you are interested in sponsorship, please send us an inquiry <a href='{{urlPrefix}}/{{linkLang}}/sponsors'>using this form.</a>",
					},
					{
						title: "Is participation free of charge?",
						short: "",
						full: "Unfortunately not. <a href='{{urlPrefix}}/{{linkLang}}/{{event}}/#tickets'>Check out the tickets</a>",
					},
					{
						title: "Can I get a refund if I can not longer attend?",
						short: "",
						full: "No, we do not provide refunds, but we can authorize ticket transfer.<br/>Please contact us at <a href='mailto:info@weblica.hr' targget='_blank'>info@weblica.hr</a>.",
					},
					{
						title: "Will it be possible to park a car somewhere?",
						short: "",
						full: "Yes, free parking is available.",
					},
					// {
					// 	title: "x",
					// 	short: "",
					// 	full: ""
					// },
				],
			},
			news: {
				hr: [],
				en: [],
			},
			extraContent: [],
		},
	},
	tickets: [ // TODO - generic tickets - this data is used ONLY if event-specific tickets are not defined
		// {
		// 	ident: "student",
		// 	// soldOut: true, // for manual control - if true, ticket count is ignored
		// 	ticketingSystem: {
		// 		maxAvailable: 25,
		// 		categoryName: "Student",
		// 	},
		// 	icon: "student",
		// 	title: {
		// 		hr: "Student",
		// 		en: "Student",
		// 	},
		// 	remark: {
		// 		hr: "",
		// 		en: "Your status will be checked at entry!"
		// 	},
		// 	price: 24,
		// 	listed: true,
		// 	available: true,
		// 	limited: true,
		// 	// special: true,
		// 	startDate: "2025-06-01",
		// 	endDate: "2026-05-08 08:00:00",
		// 	access: {
		// 		conference: true,
		// 		workshops: true,
		// 		snacks: true,
		// 		three_meals: true,
		// 		chill_zone: true,
		// 		after: true,
		// 		goodies: true,
		// 		extra_madjerka: true,
		// 		extra_supporter: false,
		// 	},
		// },
		// {
		// 	ident: "early",
		// 	ticketingSystem: {
		// 		maxAvailable: 50,
		// 		categoryName: "Early",
		// 	},
		// 	icon: "clock",
		// 	title: {
		// 		hr: "Early",
		// 		en: "Early",
		// 	},
		// 	// remark: {
		// 	// 	hr: "",
		// 	// 	en: "Get this one and pay half the price!"
		// 	// },
		// 	price: 60,
		// 	listed: true,
		// 	available: true,
		// 	limited: true,
		// 	// special: false,
		// 	startDate: "2025-06-01",
		// 	endDate: "2025-10-31 23:59:59",
		// 	access: {
		// 		conference: true,
		// 		workshops: true,
		// 		snacks: true,
		// 		three_meals: true,
		// 		chill_zone: true,
		// 		after: true,
		// 		goodies: true,
		// 		extra_madjerka: true,
		// 		extra_supporter: false,
		// 	},
		// },
		// {
		// 	ident: "mini_sponsor",
		// 	ticketingSystem: {
		// 		maxAvailable: 50,
		// 		categoryName: "Mini Sponsor",
		// 	},
		// 	icon: "friend",
		// 	title: {
		// 		hr: "",
		// 		en: "Mini Sponsor",
		// 	},
		// 	remark: {
		// 		hr: "",
		// 		en: "If you want to show extra support, and get some extra perks at the event, this is a ticket for you!"
		// 	},
		// 	price: 120,
		// 	listed: true,
		// 	available: true,
		// 	limited: true,
		// 	special: true,
		// 	startDate: "2025-06-01",
		// 	endDate: "2025-10-31 23:59:59",
		// 	access: {
		// 		conference: true,
		// 		workshops: true,
		// 		snacks: true,
		// 		three_meals: true,
		// 		chill_zone: true,
		// 		after: true,
		// 		goodies: true,
		// 		extra_madjerka: true,
		// 		extra_supporter: true,
		// 	},
		// },
		{
			ident: "regular",
			ticketingSystem: {
				maxAvailable: 250,
				categoryName: "Regular",
			},
			icon: "standard",
			title: {
				hr: "Regular",
				en: "Regular",
			},
			// remark: {
			// 	hr: "",
			// 	en: ""
			// },
			// description: {
			// 	hr: "",
			// 	en: ""
			// },
			description_below: {
				blocks: [
					{
						width: "twoThirds",
						text: {
							hr: [
								"<h3>Smještaj</h3>",
								"<p>Za posjetitelje Weblice su dostupne posebne cijene:</p>",
								"<ul>",
								"<li>Standardna jednokrevetna soba - <b>95€</b></li>",
								"<li>Standardna dvokrevetna soba - <b>120€</b></li>",
								"<li>Pristup wellnessu - <b>15€</b></li>",
								"<li>Bazeni \"Temple of Life\" - <b>10€</b></li>",
								"</ul>",
								"<br/>",
								"<p>* dodatno se naplaćuje boravišna pristojba u iznosu od 2€/dan/osoba</p>",
								"<p><b>Važno</b>: Za rezervaciju smještaja potrebno je imati kupljenu ulaznicu za Weblicu 2026.",
								"Nakon kupnje ulaznice, molimo Vas da nam se javite na <a href='mailto:info@weblica.hr'>info@weblica.hr</a> kako bismo Vam poslali poveznicu za rezervaciju smještaja.</p>"
							],
							en: [
								"<h3>Accomodation</h3>",
								"<p>Special rates available for Weblica atendees:</p>",
								"<ul>",
								"<li>Standard single room - <b>95€</b></li>",
								"<li>Standard double room - <b>120€</b></li>",
								"<li>Wellness access - <b>15€</b></li>",
								"<li>\"Temple of Life\" pools - <b>10€</b></li>",
								"</ul>",
								"<br/>",
								"<p><b>Important</b>: To get the special rate, you will need a valid Weblica ticket!</p>"
							],
						},
					},
					{
						width: "third",
						gallery: [
							{
								img: "terme_sv_martin_1.jpg",
							},
							{
								img: "terme_sv_martin_2.jpg",
							},
							{
								img: "terme_sv_martin_3.jpg",
							},
							{
								img: "terme_sv_martin_4.jpg",
							},
						],
					}
				],
			},
			price: 60,
			listed: true,
			available: true,
			startDate: "2025-11-01",
			endDate: "2026-05-08 23:59:59",
			access: {
				conference: true,
				// workshops: true,
				snacks: true,
				lunch: true,
				// three_meals: true,
				// chill_zone: true,
				// after: true,
				goodies: true,
				// extra_madjerka: true,
				// extra_supporter: false,
			},
		},
	],
	news: {
		// generic - show on all events - this data comes after event-specific items generating combined data
		hr: [],
		en: [],
	},
	faq: {
		// generic - show on all events - this data comes after event-specific items generating combined data
		hr: [],
		en: [
			// {
			// 	title: "Generic FAQ Entry #1",
			// 	short: "",
			// 	full: "Does this work? If so, this will be visible!",
			// },
		],
	},
	venues: [
		// generic venues - for easy reuse
		// {
		{
			ident: "terme-sveti-martin",
			name: {
				hr: "Terme Sveti Martin",
				en: "Terme Sveti Martin",
			},
			nameAlt: {
				hr: "Terme Sveti Martin",
				en: "Terme Sveti Martin",
			},
			street: "Izvorska 3",
			postalCode: "40313",
			city: "Sveti Martin Na Muri",
			country: "Croatia",
			countryShort: "HR",
			mapImage: "terme-location.png",
			mapUrl:
				"https://maps.app.goo.gl/wWQFnu7iGn3KbkCG7",
			images: [
				{
					// title: "Zgrada Doma kulture",
					img: "terme-0.jpg",
				},
				{
					// title: "Zgrada Doma kulture",
					img: "terme-1.jpg",
				},
				{
					// title: "Zgrada Doma kulture",
					img: "terme-2.jpg",
				},
				{
					// title: "Zgrada Doma kulture",
					img: "terme-3.jpg",
				}
			],
		}
	],
	sponsors: {}, // TODO
	exhibitors: [],
	partners: {},
	mediaPartners: [], // TODO
	survey: {
		options: {
			combinedEvents: ["weblica", "worklica"] // if defined, survey will show combined title + combined sessions (separated into section with event name)
		},
		// generic survey questions (used only if event specific are not defined)
		visitors: [
			{
				// OK
				required: true,
				question: {
					hr: "Koliko ste općenito zadovoljni događajem?",
					en: "How satisfied were you with the event in general?",
				},
				stars: true,
				comment_opt: true
			},
			{
				// OK
				required: true,
				question: {
					hr: "Koliko ste zadovoljni ukupnom kvalitetom predavanja?",
					en: "How satisfied are you with the general quality of the sessions?",
				},
				stars: true,
				comment_opt: true,
			},
			{
				// OK
				question: {
					hr: "Koje je bilo Vaše najdraže iskustvo ili trenutak događaja?",
					en: "What was your favorite experience or moment of the event?",
				},
				comment: true,
			},
			{
				// OK
				question: {
					hr: "Što bismo mogli poboljšati?",
					en: "What could we improve on?",
				},
				comment: true,
			},
			{
				// OK
				question: {
					hr: "Da li je događaj ispunio vaša očekivanja?",
					en: "Did the event meet your expectations?",
				},
				boolean: true,
				comment_opt: true,
			},
			{
				// OK
				question: {
					hr: "Kolika je vjerojatnost da ćete u budućnosti posjećivati ​​naše događaje?",
					en: "How likely would you be to attend our events in the future?",
				},
				stars: true,
				comment_opt: true,
			},
			{
				// OK
				question: {
					hr: "Biste li naše događaje preporučili prijatelju ili kolegi?",
					en: "Would you recommend our events to a friend or colleague?",
				},
				boolean: true,
				comment_opt: true,
			},
			{
				// OK
				question: {
					hr: "Jeste li imali priliku i mjesto za postavljanje pitanja i sudjelovanje?",
					en: "Did you have an opportunity and place to ask questions and participate?",
				},
				boolean: true,
				comment_opt: true,
			},
			{
				// OK
				question: {
					hr: "Koliko ste bili zadovoljni pruženim mogućnostima umrežavanja?",
					en: "How satisfied were you with the networking opportunities provided?",
				},
				stars: true,
				comment_opt: true,
			},
			{
				// OK
				question: {
					hr: "Kako ste saznali za ovaj događaj?",
					en: "How did you hear about this event?",
				},
				options: {
					type: "checkbox",
					items: [
						{
							value: "colleague-friend",
							text: {
								hr: "Kolega/Prijatelj/Poznanik",
								en: "Colleague/Friend/Acquaintance",
							},
						},
						{
							value: "social-network",
							text: {
								hr: "Društvene mreže",
								en: "Social network",
							},
						},
						{
							value: "portal",
							text: {
								hr: "IT portal",
								en: "IT portal",
							},
						},
						{
							value: "newsletter",
							text: {
								hr: "Newsletter",
								en: "Newsletter",
							},
						},
						{
							value: "poster",
							text: {
								hr: "Plakat",
								en: "Poster",
							},
						},
						{
							value: "other",
							text: {
								hr: "Neki drugi način ...",
								en: "Some other way ...",
							},
						},
					],
				},
				comment_opt: true,
				comment_placeholder: {
					hr: "Ako ste saznali na neki drugi način, molimo da ovdje napišete kako?",
					en: "If you heard about this event in another way, please tell us how?",
				},
			},
			{
				// OK
				question: {
					hr: "Jeste li već bili na ovom događaju?",
					en: "Have you attended this event before?",
				},
				boolean: true,
				comment_opt: true,
			},
			{
				// OK
				question: {
					hr: "Koliko Vam je osoblje bilo od pomoći?",
					en: "How helpful was the staff at the event?",
				},
				stars: true,
				comment_opt: true,
			},
			{
				// OK
				question: {
					hr: "Koliko je platforma za događaj bila jednostavna za navigaciju?",
					en: "How easy-to-navigate was the platform for the event?",
				},
				stars: true,
				comment_opt: true,
			},
			{
				// OK - ADDED
				question: {
					hr: "Da li su oznake u i oko prostora bile dostatne za snalaženje?",
					en: "Were the markings in and around the event area sufficient for navigation?",
				},
				stars: true,
				comment_opt: true,
			},
			{
				// OK
				question: {
					hr: "Koje biste teme voljeli vidjeti više na budućim događanjima?",
					en: "What topics would you want to see more of at future events?",
				},
				comment: true,
			},
			{
				// OK
				question: {
					hr: "Molimo podijelite sve dodatne komentare, misli, prijedloge za buduće događaje.",
					en: "Please share any additional comments, thoughts, suggestions for future events.",
				},
				comment: true,
			},
		],
		speakers: [
			{
				// OK
				required: true,
				question: {
					hr: "Koliko ste općenito zadovoljni događajem?",
					en: "How satisfied were you with the event in general?",
				},
				stars: true,
				comment_opt: true,
			},
			{
				// OK
				question: {
					hr: "Koje je bilo Vaše najdraže iskustvo ili trenutak događaja?",
					en: "What was your favorite experience or moment of the event?",
				},
				comment: true,
			},
			{
				// OK
				question: {
					hr: "Gdje ste saznali da se možete prijaviti kao predavač na našoj konferenciji?",
					en: "Where did you find out that you can register as a lecturer at our conference?",
				},
				comment: true,
			},
			{
				// OK
				question: {
					hr: "Jesu li tehnička podrška i oprema zadovoljili vaše potrebe tijekom predavanja?",
					en: "Did the technical support and equipment meet your needs during the presentation?",
				},
				boolean: true,
				comment_opt: true,
			},
			{
				// OK
				question: {
					hr: "Kako ocjenjujete organizaciju i komunikaciju s organizacijskim timom prije i tijekom konferencije?",
					en: "How do you rate the organization and communication with the organizing team before and during the conference?",
				},
				stars: true,
				comment_opt: true,
			},
			{
				// OK
				question: {
					hr: "Kako biste ocijenili interes i angažman publike tijekom vašeg predavanja?",
					en: "How would you assess the interest and engagement of the audience during your presentation?",
				},
				stars: true,
				comment_opt: true,
			},
			{
				// OK
				question: {
					hr: "Jesu li vam pružene dovoljne prilike za networking i interakciju s ostalim predavačima i sudionicima?",
					en: "Were you provided with sufficient opportunities for networking and interaction with other speakers and participants?",
				},
				boolean: true,
				comment_opt: true,
			},
			{
				// OK
				question: {
					hr: "Postoji li nešto što bi moglo biti poboljšano u vezi s vašim iskustvom na konferenciji?",
					en: "Is there anything that could be improved in relation to your experience at the conference?",
				},
				comment: true,
			},
			{
				// OK
				// required: true,
				question: {
					hr: "Biste li se željeli vratiti kao predavač na budućim izdanjima naše konferencije?",
					en: "Would you like to return as a speaker at future editions of our conference?",
				},
				boolean: true,
				comment_opt: true,
			},
			{
				// OK
				question: {
					hr: "Imate li preporuke za teme ili sadržaje koji bi mogli obogatiti buduća izdanja naše konferencije?",
					en: "Do you have any recommendations for topics or content that could enrich future editions of our conference?",
				},
				comment: true,
			},
		],
	},
}
